function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const submitToElsterApi = buildService('/claim_project_reports/{id}/submit_project_to_elster', {
  only: ['all', 'base', 'create']
});
const elsterApi = buildService('/companies/{id}/elsters', {
  only: ['create', 'update']
});
const createElsterStatusApi = buildService('/companies/{id}/create_elster_status', {
  only: ['all', 'base']
});
const updateElsterDateStatusApi = buildService('/elsters/{id}/update_elster_date_status', {
  only: ['all', 'base']
});
const submittedProjectDateChangeApi = buildService('/claim_project_reports/{id}/submitted_project_date_change', {
  only: ['update']
});
const submittedProjectDateChangeStatusApi = buildService('/claim_project_reports/{id}/submitted_project_date_change_status', {
  only: ['all', 'base']
});
const apiMap = {
  submitToElsterApi: submitToElsterApi,
  elsterApi: elsterApi,
  createElsterStatusApi: createElsterStatusApi,
  updateElsterDateStatusApi: updateElsterDateStatusApi,
  submittedProjectDateChangeApi: submittedProjectDateChangeApi,
  submittedProjectDateChangeStatusApi: submittedProjectDateChangeStatusApi
};
const elsterSubmissionAndDataChangeService = {
  useFetchSubmitStatusWithInterval: (projectId, setLoading, apiName) => {
    const {
      interval,
      setInterval,
      stateVar: submitStatus,
      setStateVar: setSubmitStatus
    } = serviceMethods.useFetchWithInterval({
      api: apiMap[apiName],
      callback: useCallback(async () => {
        const statuses = await apiMap[apiName].all(projectId);
        // Return the last job from the array (most recent), or null if array is empty
        return Array.isArray(statuses) && statuses.length > 0 ? statuses[0] : null;
      }, [projectId, apiName]),
      setLoading
    });
    return {
      submitStatus,
      setSubmitStatus,
      interval,
      setInterval
    };
  },
  useCreate: (projectId, setLoading, setSubmitStatus, apiName) => {
    const createSubmitStatus = serviceMethods.useCreate({
      callback: useCallback(async payload => {
        const newStatus = await apiMap[apiName].create(projectId, payload);
        if (setSubmitStatus) {
          setSubmitStatus(_objectSpread({}, newStatus));
        }
        return newStatus;
      }, [projectId, setSubmitStatus, apiName]),
      setLoading
    });
    return [createSubmitStatus];
  },
  useUpdate: (resourceId, subResourceId, setLoading, setSubmitStatus, apiName) => {
    const updateSubmitStatus = serviceMethods.useUpdate({
      callback: useCallback(async payload => {
        const updateId = subResourceId;
        const newStatus = await apiMap[apiName].update(resourceId, updateId, payload);
        if (setSubmitStatus) {
          setSubmitStatus(_objectSpread({}, newStatus));
        }
        return newStatus;
      }, [resourceId, subResourceId, setSubmitStatus, apiName]),
      setLoading
    });
    return updateSubmitStatus;
  }
};
elsterSubmissionAndDataChangeService.useCrud = function (projectId, setLoading, apiName) {
  let statusApiName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'submitToElsterApi';
  const {
    submitStatus,
    setSubmitStatus,
    interval,
    setInterval
  } = elsterSubmissionAndDataChangeService.useFetchSubmitStatusWithInterval(projectId, setLoading, statusApiName);
  const [createSubmitStatus] = elsterSubmissionAndDataChangeService.useCreate(projectId, setLoading, setSubmitStatus, apiName);
  return {
    submitStatus,
    createSubmitStatus,
    interval
  };
};
elsterSubmissionAndDataChangeService.useUpdateCrud = (resourceId, subResourceId, setLoading, apiName, statusApiName) => {
  // For status polling, use resourceId (or subResourceId if it's the main identifier for status)
  // For elsterApi status, we use elsterId (subResourceId), for project date change, we use projectId (resourceId)
  const statusPollingId = apiName === 'elsterApi' ? subResourceId : resourceId;
  const {
    submitStatus,
    setSubmitStatus,
    interval,
    setInterval
  } = elsterSubmissionAndDataChangeService.useFetchSubmitStatusWithInterval(statusPollingId, setLoading, statusApiName);
  const updateSubmitStatus = elsterSubmissionAndDataChangeService.useUpdate(resourceId, subResourceId, setLoading, setSubmitStatus, apiName);
  return {
    submitStatus,
    updateSubmitStatus,
    interval
  };
};
export default elsterSubmissionAndDataChangeService;